import { FC } from 'react';
import { useAuth } from '@/shared/hooks/useAuth/useAuth';
import { useProfileFetching } from '@/shared/hooks';
import { Navigate } from 'react-router';
import { getRouteLogin } from '@/shared/const/router.const';

type IAuthProviderProps = {
  children: React.ReactNode;
};

export const AuthProvider: FC<IAuthProviderProps> = ({ children }) => {
  const { isAuthenticated } = useAuth();

  //"Getme" request
  useProfileFetching(isAuthenticated);

  if (!isAuthenticated) {
    return <Navigate to={getRouteLogin()} />;
  }

  return <div>{children}</div>;
};
